// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.zjiF3rUPebYidHf3mpcj {
    &[data-inactive] {
        opacity: 0.3;
        cursor: default;
    }
}

.T8zTTj84OLO2npoNbokl {
  width: 8px;
  height: 8px;
  border-radius: 10px;
  transition: width 250ms ease;
  background-color: lightgrey;

  &[data-active] {
    background-color: #000;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/mantineStyles.module.css"],"names":[],"mappings":";AACA;IACI;QACI,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,4BAA4B;EAC5B,2BAA2B;;EAE3B;IACE,sBAAsB;EACxB;AACF","sourcesContent":["\n.control {\n    &[data-inactive] {\n        opacity: 0.3;\n        cursor: default;\n    }\n}\n\n.indicator {\n  width: 8px;\n  height: 8px;\n  border-radius: 10px;\n  transition: width 250ms ease;\n  background-color: lightgrey;\n\n  &[data-active] {\n    background-color: #000;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"control": `zjiF3rUPebYidHf3mpcj`,
	"indicator": `T8zTTj84OLO2npoNbokl`
};
export default ___CSS_LOADER_EXPORT___;
